define.alias("ember-power-select/helpers/ember-power-select-is-equal", "media/helpers/ember-power-select-is-equal");